module.exports = __webpack_public_path__ + "img/l1.fa5c3fdc.jpg";